import {useEffect} from "react"

import cn from 'clsx'

import {useAppDispatch, useAppSelector} from "@App/hooks"
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'
import { ToolTip } from '@App/ui/crypto_exchange/desktop/components/controls/ToolTip'

import {asyncGetOrders} from "@Redux/slices/reports/ReportsSlice";
import {selectOrdersList} from "@Redux/slices/trade/trades/selectors"
import { Order } from "@Redux/slices/trade/trades/types"
import {currentWallet} from "@Redux/slices/user/selectors"

import {formatDate, formatTime, useCopyText, useOrders} from '../../model'

import s from './styles.module.scss'

export const OrdersTable = ({ onRowClick }: { onRowClick?: (val: Order) => void }) => {
  const { orders } = useOrders()
  const newOrders = useAppSelector((state) => selectOrdersList(state))
  const currWallet = useAppSelector(currentWallet)
  const dispatch = useAppDispatch()

  useEffect(() => {
    currWallet?.id && dispatch(asyncGetOrders(currWallet?.id))
  }, [newOrders, currWallet]);

  const columns: { title: string; width: string }[] = [
    { title: 'Date', width: '2%' },
    { title: 'Time', width: '2%' },
    { title: 'Market/ Size', width: '10%' },
    { title: 'Status', width: '9%' },
    { title: 'Type', width: '15%' },
    { title: 'Target price', width: '8%' },

    { title: 'ID', width: '1%' },
  ]

  const { copyText } = useCopyText()

  return (
    <div className={s.tableContainer}>
      <table className={s.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th style={{ width: col.width }} key={col.title} className={s[col.title.toLocaleLowerCase()]}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {orders.map((order) => (
            <tr className={s.row} key={order.id} onClick={() => onRowClick?.(order)}>
              <td className={s.col}>{formatDate(order.open_time)}</td>
              <td className={s.col}>{formatTime(order.open_time)}</td>
              <td className={cn(s.col, s.info)}>
                <MarketIcon
                  source_currency={order.market.source}
                  target_currency={order.market.target}
                />{' '}
                {order.market.title}
                <span className={cn(s.quantity, order.action_type === 'buy' && s.buy)}>{order.quantity}</span>
              </td>
              <td className={s.col}>{order.status}</td>
              <td className={s.col}>{order.action_type}</td>
              <td className={s.col}>{order.open_rate}</td>

              <td className={s.col}>
                <ToolTip content={<span className={s.toolTip}>{order.front_id}</span>}>
                  <span className={s.idBadge} onClick={() => copyText(order.front_id)}>
                    ID
                  </span>
                </ToolTip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
